import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/service/auth.service';
import { OrganisationService } from '../organisation/organisation/services/organisation.service';
import { RequestService } from '../requests/services/requests.services';
import { TaskService } from '../tasks/services/tasks.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewChecked, OnDestroy {
  activeRequestCount = 0;
  pendingTasksCount = 0;
  isrequestCountLoaded = false;
  istaskCountLoaded = false;
  organisationSubscriber?: Subscription;
  activeRequestSubscription?: Subscription;
  pendingTasksCountSubscription?: Subscription;
  currentOrganisation: any = ''
  externalLink = '';
  currentUser = '';
  constructor(private readonly requestService: RequestService,
    private readonly taskService: TaskService,
    private readonly authService: AuthService,    
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly organisationService: OrganisationService) {
  }
  ngOnDestroy(): void {
    this.activeRequestSubscription?.unsubscribe();
    this.pendingTasksCountSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }      
        this.externalLink = "https://dev.azure.com/" + this.currentOrganisation;
        this.currentUser = this.authService.upn;
      }
    });
    if (this.authService.isAuthorized()) {
      if (this.currentOrganisation == null || this.currentOrganisation === "") {
        this.router.navigate(['/organisation'], { relativeTo: this.route });        
      }
      if (this.currentOrganisation != null && this.currentOrganisation !== "") {
        this.getActiveRequestsCount();
        this.getPendingTasksCount();
      }
    }
  }

  ngAfterViewChecked(): void {
    
  }

  getActiveRequestsCount() {
    this.activeRequestSubscription =this.requestService.getActiveRequestCount().subscribe({
      next: (data) => {
        this.activeRequestCount = data;
        this.isrequestCountLoaded = true;
        this.requestService.countEmitter.next(this.activeRequestCount);
      }
    });    
  }

  getPendingTasksCount() {
    this.pendingTasksCountSubscription=this.taskService.getPendingTasksCount().subscribe({
      next: (data) => {
        this.pendingTasksCount = data;
        this.istaskCountLoaded = true;
        this.taskService.countEmitter.next(this.pendingTasksCount);
      }
    });
  }
}
